import { ERROR_CODES } from '@garage/shared';
import { ApiError } from '../../shared/api.js';

/** Vague 7 : action refusée à une session de démonstration (403 `demo_forbidden`). */
export const DEMO_FORBIDDEN_MESSAGE = 'Indisponible en démonstration.';

/**
 * 429 `rate_limited` : délai donné par l'API (`details.retryAfterSeconds`, par exemple un compte bloqué
 * 30 minutes après 5 échecs de connexion), arrondi à la minute supérieure.
 */
export function tooManyAttempts(err: ApiError): string {
  const raw = (err.details as { retryAfterSeconds?: unknown } | undefined)?.retryAfterSeconds;
  const seconds = typeof raw === 'number' && Number.isFinite(raw) && raw > 0 ? raw : null;
  if (seconds === null) return 'Trop de tentatives. Patientez quelques minutes.';
  const minutes = Math.ceil(seconds / 60);
  return minutes <= 1 ? 'Trop de tentatives : réessayez dans une minute.' : `Trop de tentatives : réessayez dans ${minutes} minutes.`;
}

/** Message lisible pour une erreur d'appel. Le serveur reste seul juge des droits. */
export function errorMessage(err: unknown): string {
  if (err instanceof ApiError) {
    // Vague 7 : refus propres à la démonstration et aux modules désactivés.
    if (err.code === ERROR_CODES.demoForbidden) return DEMO_FORBIDDEN_MESSAGE;
    if (err.code === ERROR_CODES.demoQuotaReached) return 'Limite de la démonstration atteinte : cette démonstration ne permet pas d’en créer davantage.';
    if (err.code === ERROR_CODES.moduleDisabled) return 'Ce module est désactivé dans votre garage (Compte → Modules).';
    switch (err.status) {
      case 401:
        return 'Votre session a expiré. Reconnectez-vous.';
      case 403:
        return 'Cette action ne vous est pas autorisée.';
      case 404:
        return 'Élément introuvable.';
      case 409:
        return err.message || 'Cette action a déjà été faite ou n’est plus possible.';
      case 429:
        return tooManyAttempts(err);
      case 501:
        return 'Fonction pas encore disponible.';
      default:
        if (err.status >= 500) return 'Le serveur ne répond pas correctement. Réessayez.';
        return err.message || 'Demande refusée.';
    }
  }
  if (err instanceof TypeError) return 'Connexion impossible. Vérifiez le réseau et réessayez.';
  return 'Une erreur est survenue. Réessayez.';
}
